module.exports = "/_next/static/images/AIAnnouncements-d5e5bf4f288ac9174fb4f4141f872db8.webp";